import { IListItem } from '../../interfaces/IListItem';

export interface IListItemProps {
    item: IListItem;
}
export const ListItem: React.FC<IListItemProps> = ({ item }) => {
    return <li key={item.id}>{item.name}</li>;
};
